module.exports = __webpack_public_path__ + "static/img/logo-index.7573084a.png";